'use client';

import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

// Types
import { TooltipProps } from '../../types/display/tooltip';

export const Tooltip = ({ id, children, tooltip }: TooltipProps) => {
  return (
    <>
      {id && (
        <ReactTooltip
          id={id}
          place="bottom"
          content={tooltip}
          className="tooltip"
          anchorSelect={`#${id}`}
        />
      )}

      {children}
    </>
  );
};
